module.exports = __webpack_public_path__ + "static/media/29ADMSPC21.0fc6719b.jpg";